import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getAccessVehiclesService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values)
        const response = await customFetch(`${API_URL}vehiclesAccess`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const getExitVehiclesService = async (values) => {
    try {
        const configs = getConfigExactian('POST', values)
        const response = await customFetch(`${API_URL}vehiclesIn`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}